/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_SolutionsInputs */

const en_mk_nav_solutions = /** @type {(inputs: Mk_Nav_SolutionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solutions`)
};

const id_mk_nav_solutions = /** @type {(inputs: Mk_Nav_SolutionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solusi`)
};

/**
* | output |
* | --- |
* | "Solutions" |
*
* @param {Mk_Nav_SolutionsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_solutions = /** @type {((inputs?: Mk_Nav_SolutionsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_SolutionsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_solutions(inputs)
	return en_mk_nav_solutions(inputs)
});